import { useEffect, useState } from "react";
import { Trophy } from "@phosphor-icons/react";

const DEFAULT_MESSAGES = [
  "Honored to be named Best of Northern Utah 2026 — Business Consulting",
  "Honored to be a winner of the Trusted Business Awards",
];

const ROTATE_MS = 5000;
const FADE_MS = 500;

export default function AwardStrip({ c }) {
  // Preserve CMS-editability of the primary line; append the Trusted Business Awards line.
  const messages = [
    c("award_strip", DEFAULT_MESSAGES[0]),
    DEFAULT_MESSAGES[1],
  ];

  const [idx, setIdx] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setIdx((i) => (i + 1) % messages.length);
        setVisible(true);
      }, FADE_MS);
    }, ROTATE_MS);
    return () => clearInterval(interval);
  }, [messages.length]);

  return (
    <div data-testid="award-strip" className="bg-cvc-navy text-cvc-cream">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-2.5 flex items-center justify-center gap-3 text-center">
        <Trophy size={16} weight="duotone" className="text-cvc-cream/90 shrink-0" />
        <p
          data-testid="award-strip-text"
          className="font-body text-xs sm:text-sm tracking-wide transition-opacity duration-500"
          style={{ opacity: visible ? 1 : 0 }}
        >
          {messages[idx]}
        </p>
      </div>
    </div>
  );
}
